import {probesActionTypes} from './home.actionTypes';

const initialState = {
  data: {
    total: 0,
    page: 0,
    probes: [],
  },
  hashData: {
    total: 0,
    page: 0,
    probes: [],
  },
  selectedProbe: null,
  errors: undefined,
  loading: false,
  hashLoading: false,
  bannerData: null,
  filterOrder: null,
  searchProbes: {
    total: 0,
    page: 0,
    probes: [],
  },
  mutiFilteredData: {total: 0, page: 0, probes: []},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case probesActionTypes.FETCH_PROBES_REQUEST: {
      return {...state, loading: true};
    }
    case probesActionTypes.FETCH_PROBES_SUCCESS: {
      return {...state, loading: false, data: action.payload};
    }
    case probesActionTypes.FETCH_PROBES_ERROR: {
      return {...state, loading: false, errors: action.payload};
    }
    case probesActionTypes.FETCH_HASHTAG_PROBES_REQUEST: {
      return {...state, hashLoading: true};
    }
    case probesActionTypes.FETCH_HASHTAG_PROBES_SUCCESS: {
      return {...state, hashLoading: false, hashData: action.payload};
    }
    case probesActionTypes.FETCH_HASHTAG_PROBES_ERROR: {
      return {...state, hashLoading: false, errors: action.payload};
    }
    case probesActionTypes.BANNER_PROBES_SUCCESS: {
      return {...state, bannerData: action.payload};
    }
    case probesActionTypes.SEARCH_PROBE_SUCCESS: {
      return {...state, searchProbes: action.payload};
    }
    case probesActionTypes.SET_SORTING_ORDER: {
      return {...state, sortingOrder: action.payload};
    }
    case probesActionTypes.SET_FILTER_ORDER: {
      return {...state, filterOrder: action.payload};
    }
    case probesActionTypes.FETCH_PROBES_MULTI_SUCCESS: {
      return {...state, loading: false, mutiFilteredData: action.payload};
    }
    case probesActionTypes.SET_EMPTY_PROBES: {
      return {...state, loading: false, mutiFilteredData: {}};
    }
    default: {
      return state;
    }
  }
};

export {reducer as probesReducer};
